import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import * as Lottomart from './lottomart/lottomart.index';
import * as Backoffice from './backoffice/backoffice.index';
import { UnsupportedTableCellComponent } from './shared/unsupported/table-cell/unsupported-table-cell.component';
import { TextFormFieldComponent } from './shared/text/form-field/text-form-field.component';
import { NumberFormFieldComponent } from './shared/number/form-field/number-form-field.component';
import { UnsupportedFormFieldComponent } from './shared/unsupported/form-field/unsupported-form-field.component';
import { CheckboxFormFieldComponent } from './shared/checkbox/form-field/checkbox-form-field.component';
import { OptionFormFieldComponent } from './shared/option/form-field/option-form-field.component';
import { DateFormFieldComponent } from './shared/date/form-field/date-form-field.component';
import { SymbolTableCellComponent } from './shared/symbol/table-cell/symbol-table-cell.component';
import { SymbolFormFieldComponent } from './shared/symbol/form-field/symbol-form-field.component';
import { RateTableCellComponent } from './shared/rate/table-cell/rate-table-cell.component';
import { RateFormFieldComponent } from './shared/rate/form-field/rate-form-field.component';
import { HtmlFormFieldComponent } from './shared/html/form-field/html-form-field.component';
import { HtmlPreviewDialogComponent } from './shared/html/preview-dialog/html-preview-dialog.component';
import { ColorFormFieldComponent } from './shared/color/form-field/color-form-field.component';
import { MultiOptionFormFieldComponent } from './shared/multi-option/form-field/multi-option-form-field.component';
import { EmojiTableCellComponent } from './shared/emoji/table-cell/emoji-table-cell.component';
import { EmojiFormFieldComponent } from './shared/emoji/form-field/emoji-form-field.component';
import { MoneyFormFieldComponent } from './shared/money/form-field/money-form-field.component';
import { MoneyService } from './shared/money/money.service';
import { LookupFormFieldComponent } from './shared/lookup/single-lookup/lookup-from-field/lookup-form-field.component';
import { LookupPagedFormFieldComponent } from './shared/lookup/lookup-paged/lookup-paged-form-field/lookup-paged-form-field.component';
import { LookupPagedModalComponent } from './shared/lookup/lookup-paged/lookup-paged-modal/lookup-paged-modal.component';
import { LookupModalComponent } from './shared/lookup/lookup-modal/lookup-modal.component';
import { GameSearchModalComponent } from './shared/lookup/game-search-modal/game-search-modal.component';
import { AdminBaseModule } from '../../../common/admin-base/admin-base.module';
import { SpendingLimitComponent } from './shared/spending-limit/form-field/spending-limit.component';
import { PrizeTableFormFieldComponent } from './draws/prize-table/form-field/prize-table-form-field.component';
import { DrawOptionsFormFieldComponent } from './draws/draw-options/form-field/draw-options-form-field.component';
import { BoosterFormFieldComponent } from './draws/booster/form-field/booster-form-field.component';
import { QuickPicksFormFieldComponent } from './draws/quick-picks/form-field/quick-picks-form-field.component';
import { NestedTableFormFieldComponent } from './shared/nested-table/form-field/nested-table-form-field.component';
import { DateTimeFormFieldComponent } from './shared/date-time/form-field/date-time-form-field.component';
import { DateRangeFormFieldComponent } from './shared/date-range/form-field/date-range-form-field.component';

import { FutureDrawsFormFieldComponent } from './draws/future_draws/form-field/future-draws-form-field.component';
import { DrawLottolandComplianceComponent } from '../../dialogs/draw-lottoland-compliance/draw-lottoland-compliance.component';
import { AvatarFormFieldComponent } from './shared/avatar/form-field/avatar-form-field.component';
import { AvatarTableCellComponent } from './shared/avatar/table-cell/avatar-table-cell.component';

import { ImageTableCellComponent } from './shared/image/table-cell/image-table-cell.component';
import { ImageFormFieldComponent } from './shared/image/form-field/image-form-field.component';

import { ToggleFormFieldComponent } from './shared/toggle/form-field/toggle-form-field.component';
import { ToggleTableCellComponent } from './shared/toggle/table-cell/toggle-table-cell.component';

import { ReportFormFieldComponent } from './shared/report/form-field/report-form-field.component';

import { PropertiesFormFieldComponent } from './shared/properties/form-field/properties-form-field.component';
import { LogoFormFieldComponent } from './shared/logo/form-field/logo-form-field.component';

import { ImageUploaderTableCellComponent } from './shared/image-uploader/table-cell/image-uploader-table-cell.component';
import { ImageUploaderFormFieldComponent } from './shared/image-uploader/form-field/image-uploader-form-field.component';
import { DragDropDirective } from './shared/image-uploader/drag-drop.directive';
import { DiamondPanelFormFieldComponent } from './lottomart/diamond-panel/form-field/diamond-panel-form-field.component';
import { CardPanelFormFieldComponent } from './lottomart/card-panel/form-field/card-panel-form-field.component';
import { CardPanelTableCellComponent } from './lottomart/card-panel/table-cell/card-panel-table-cell.component';
import { HeroSlideFormFieldComponent } from './lottomart/hero-slide/form-field/hero-slide-form-field.component';
import { HeroSlidesFormFieldComponent } from './lottomart/hero-slides/form-field/hero-slides-form-field.component';
import { DisplayHeroSlideComponent } from './lottomart/hero-slide/display-hero-slide.component';
import { NestedPanelFormFieldComponent } from './shared/nested-panel/form-field/nested-panel-form-field.component';
import { GraphFormFieldComponent } from './shared/graph/form-field/graph-form-field.component';
import { LinkFormFieldComponent } from './shared/link/form-field/link-form-field.component';
import { CodeFormFieldComponent } from './shared/code/form-field/code-form-field.component';

import { FileUploadFormFieldComponent } from './shared/file-upload/form-field/file-upload-form-field.component';
import { ShapeFormFieldComponent } from './shared/shape/form-field/shape-form-field.component';
import { ShapeTableCellComponent } from './shared/shape/table-cell/shape-table-cell.component';
import { TimeFormFieldComponent } from './shared/time/form-field/time-form-field.component';

import { ChartFormFieldComponent } from './shared/chart/form-field/chart-form-field.component';

import { HtmlBlockFormFieldComponent } from './shared/html-block/form-field/html-block-form-field.component';

import { DeeplinkFormFieldComponent } from './lottomart/deeplink/form-field/deeplink-form-field.component';
import { DeeplinkTableCellComponent } from './lottomart/deeplink/table-cell/deeplink-table-cell.component';
import { BundleFormFieldComponent } from './lottomart/bundle/form-field/bundle-form-field.component';
import { OpenInPlayerFormFieldComponent } from './lottomart/open-in-player/form-field/open-in-player-form-field.component';

import { IframeFormFieldComponent } from './shared/iframe/form-field/iframe-form-field.component';

import { VideoFormFieldComponent } from './shared/video/form-field/video-form-field.component';

import { MapFormFieldComponent } from './shared/map/form-field/map-form-field.component';

import { MetricFormFieldComponent } from './shared/metric/form-field/metric-form-field.component';
import { TreeFormFieldComponent } from './shared/tree/form-field/tree-form-field.component';
import { MultiLookupFormFieldComponent } from './shared/lookup/multi-lookup/multi-lookup-form-field/multi-lookup-form-field.component';
import { StopwatchFormFieldComponent } from './shared/stopwatch/form-field/stopwatch-form-field.component';

import { CodePenFormFieldComponent } from './shared/codepen/form-field/code-pen-form-field.component';

import { RunScriptsDirective } from './shared/html/form-field/run-scripts.directive';

import { SiteTreeFormFieldComponent } from './shared/site-tree/form-field/site-tree-form-field.component';
import { SiteTreeFileDatabaseService } from './shared/site-tree/form-field/component/service/site-tree-file-database.service';

import { OddsFormFieldComponent } from './shared/odds/form-field/odds-form-field.component';
import { NewMoneyFormFieldComponent } from './shared/new-money/form-field/new-money-form-field.component';

import { DynamicLinkFormFieldComponent } from './shared/dynamic-link/form-field/dynamic-link-form-field.component';
import { SiteTreeModule } from './shared/site-tree/form-field/component/site-tree.module';
import { PlayerInfoFormFieldComponent } from './shared/player-info/form-field/player-info-form-field.component';
import { SmartFilterFormField } from './lottomart/smart-filters/form-field/smart-filter-form-field.component';
import { DurationFormFieldComponent } from './shared/duration/form-field/duration-form-field.component';
import { OptionPanelFormFieldComponent } from './shared/option-panel/form-field/option-panel-form-field.component';
import { StarFormFieldComponent } from './shared/star/form-field/star-form-field.component';
import { EntityRestrictionCheckboxFormFieldComponent } from './shared/entity-restriction-checkbox/form-field/entity-restriction-checkbox-form-field.component';
import {
  EntityRestrictionDialogComponent,
  EntityRestrictionManagerComponent,
} from './managers/entity-restriction-manager/entity-restriction-manager.component';
import { AvailabilitySummaryFormFieldComponent } from './shared/availability-summary/form-field/availability-summary-form-field.component';
import { ExternalLinkDirective } from './shared/html/form-field/external-link.directive';
import { DepositsIn24hThresholdOverrideComponent } from './player/deposits-in-24h-threshold-override/deposits-in-24h-threshold-override.component';
import { PersonalMonthlyNetLossThresholdComponent } from './player/personal-monthly-net-loss-threshold/personal-monthly-net-loss-threshold.component';
import { MoneyV2Component } from './shared-v2/money-v2/money-v2.component';
import { AffordabilitySettingsComponent } from './backoffice/affordability-settings/affordability-settings.component';
import { LifetimeNetLossThresholdsComponent } from './backoffice/lifetime-net-loss-thresholds/lifetime-net-loss-thresholds.component';
import { NetLossesComponent } from './backoffice/net-losses/net-losses.component';
import { PromotionExcludeComponent } from './player/promotion-exclude/promotion-exclude.component';
import { LifetimeDepositThresholdsComponent } from './backoffice/lifetime-deposit-thresholds/lifetime-deposit-thresholds.component';
import { PersonalLifetimeThresholdsComponent } from './player/personal-lifetime-thresholds/personal-lifetime-thresholds.component';

export const declareExportComponents = [
  TextFormFieldComponent,

  NumberFormFieldComponent,

  CheckboxFormFieldComponent,

  EntityRestrictionCheckboxFormFieldComponent,
  EntityRestrictionDialogComponent,

  OptionFormFieldComponent,

  DateFormFieldComponent,

  DateTimeFormFieldComponent,

  SymbolTableCellComponent,
  SymbolFormFieldComponent,

  RateTableCellComponent,
  RateFormFieldComponent,

  HtmlFormFieldComponent,
  HtmlPreviewDialogComponent,

  ColorFormFieldComponent,

  MultiOptionFormFieldComponent,

  EmojiTableCellComponent,
  EmojiFormFieldComponent,

  MoneyFormFieldComponent,

  UnsupportedTableCellComponent,
  UnsupportedFormFieldComponent,

  LookupFormFieldComponent,
  MultiLookupFormFieldComponent,
  LookupModalComponent,
  GameSearchModalComponent,
  LookupPagedFormFieldComponent,
  LookupPagedModalComponent,

  SpendingLimitComponent,

  NestedTableFormFieldComponent,

  PrizeTableFormFieldComponent,
  DrawOptionsFormFieldComponent,
  BoosterFormFieldComponent,
  QuickPicksFormFieldComponent,
  FutureDrawsFormFieldComponent,

  AvatarFormFieldComponent,
  AvatarTableCellComponent,

  ImageTableCellComponent,
  ImageFormFieldComponent,

  ToggleFormFieldComponent,
  ToggleTableCellComponent,

  ReportFormFieldComponent,
  PropertiesFormFieldComponent,

  DrawLottolandComplianceComponent,
  LogoFormFieldComponent,

  NestedPanelFormFieldComponent,

  GraphFormFieldComponent,

  ImageUploaderFormFieldComponent,
  ImageUploaderTableCellComponent,

  DiamondPanelFormFieldComponent,

  CardPanelFormFieldComponent,
  CardPanelTableCellComponent,

  HeroSlideFormFieldComponent,
  HeroSlidesFormFieldComponent,

  DisplayHeroSlideComponent,

  LinkFormFieldComponent,

  CodeFormFieldComponent,

  ShapeFormFieldComponent,
  ShapeTableCellComponent,

  DateRangeFormFieldComponent,
  FileUploadFormFieldComponent,

  TimeFormFieldComponent,
  ChartFormFieldComponent,

  HtmlBlockFormFieldComponent,

  DeeplinkFormFieldComponent,
  DeeplinkTableCellComponent,

  BundleFormFieldComponent,

  OpenInPlayerFormFieldComponent,

  IframeFormFieldComponent,
  VideoFormFieldComponent,
  MapFormFieldComponent,

  MetricFormFieldComponent,
  TreeFormFieldComponent,

  StopwatchFormFieldComponent,

  CodePenFormFieldComponent,

  OddsFormFieldComponent,
  NewMoneyFormFieldComponent,

  SiteTreeFormFieldComponent,

  DynamicLinkFormFieldComponent,

  PlayerInfoFormFieldComponent,

  Backoffice.MoneylineFormFieldComponent,

  SmartFilterFormField,

  DurationFormFieldComponent,
  OptionPanelFormFieldComponent,

  StarFormFieldComponent,

  AvailabilitySummaryFormFieldComponent,
];

@NgModule({
  imports: [
    AdminBaseModule,
    // AgmCoreModule.forRoot({
    // please get your own API key here:
    // https://developers.google.com/maps/documentation/javascript/get-api-key?hl=en
    // This key belong sto me, Grant Wallace
    //    apiKey: 'AIzaSyDZof0bZN5zTi4r9hr7IItl5R42YK57cXs'
    // }),
    SiteTreeModule,
    MatExpansionModule,
    // LottomartModule
  ],
  declarations: [
    ...declareExportComponents,
    ...Lottomart.COMPONENTS,
    ...Lottomart.PAGES,
    ...Lottomart.PIPES,
    ...Backoffice.COMPONENTS,
    ...Backoffice.PAGES,
    ...Backoffice.PIPES,
    DragDropDirective,
    RunScriptsDirective,
    EntityRestrictionManagerComponent,
    EntityRestrictionDialogComponent,
    StopwatchFormFieldComponent,
    ExternalLinkDirective,
    MoneyV2Component,
    DepositsIn24hThresholdOverrideComponent,
    PersonalLifetimeThresholdsComponent,
    PersonalMonthlyNetLossThresholdComponent,
    AffordabilitySettingsComponent,
    NetLossesComponent,
    LifetimeNetLossThresholdsComponent,
    PromotionExcludeComponent,
    LifetimeDepositThresholdsComponent,
  ],
  exports: [
    ...declareExportComponents,
    ...Lottomart.PIPES,
    ...Lottomart.MODULE_EXPORTS,
    ...Backoffice.PIPES,
    ...Backoffice.MODULE_EXPORTS,
    RunScriptsDirective,
    EntityRestrictionManagerComponent,
    StopwatchFormFieldComponent,
    // LottomartModule
  ],
  providers: [MoneyService, ...Lottomart.SERVICES, ...Backoffice.SERVICES, SiteTreeFileDatabaseService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DataTypesModule {}
